import { AssistantGroup, StudentGroup } from './types';

export const STUDENT_GROUP_TEXT: Record<StudentGroup, string> = {
	A: 'A',
	A1: 'A1',
	A2: 'A2',
	AM: 'AM',
	B: 'B',
	B1: 'B1',
	B96: 'B96',
	Ba: 'Ba',
	BpE: 'B+E',
	C: 'C',
	C1: 'C1',
	C1pE: 'C1+E',
	CpE: 'C+E',
	D: 'D',
	D1: 'D1',
	D1pE: 'D1+E',
	DpE: 'D+E',
	T: 'T',
};

export const ASSISTANT_GROUP_TEXT: Record<AssistantGroup, string> = {
	PV_ZP: 'Praktická výcvik zdravotnické přípravy',
	ZP: 'Zdravotnická příprava',
};

export const MAX_URL_LEN = 10000;

export const COUNTRIES = [
	'Afghánistán',
	'Albánie',
	'Alžírsko',
	'Americká Samoa',
	'Andorra',
	'Angola',
	'Anguilla',
	'Antarktida',
	'Antigua a Barbuda',
	'Argentina',
	'Arménie',
	'Aruba',
	'Austrálie',
	'Rakousko',
	'Ázerbájdžán',
	'Bahamy',
	'Bahrajn',
	'Bangladéš',
	'Barbados',
	'Bělorusko',
	'Belgie',
	'Belize',
	'Benin',
	'Bermudy',
	'Bhútán',
	'Bolívie',
	'Bonaire, Sint Eustatius a Saba',
	'Bosna a Hercegovina',
	'Botswana',
	'Bouvetův ostrov',
	'Brazílie',
	'Britské indickooceánské území',
	'Brunej',
	'Bulharsko',
	'Burkina Faso',
	'Burundi',
	'Kapverdy',
	'Kambodža',
	'Kamerun',
	'Kanada',
	'Kajmanské ostrovy',
	'Středoafrická republika',
	'Čad',
	'Chile',
	'Čína',
	'Vánoční ostrov',
	'Kokosové ostrovy',
	'Kolumbie',
	'Komory',
	'Kongo-Kinshasa',
	'Kongo-Brazzaville',
	'Cookovy ostrovy',
	'Kostarika',
	'Chorvatsko',
	'Kuba',
	'Curaçao',
	'Kypr',
	'Česká republika',
	'Pobřeží slonoviny',
	'Dánsko',
	'Džibutsko',
	'Dominika',
	'Dominikánská republika',
	'Ekvádor',
	'Egypt',
	'Salvador',
	'Rovníková Guinea',
	'Eritrea',
	'Estonsko',
	'Svazijsko',
	'Etiopie',
	'Falklandy',
	'Faerské ostrovy',
	'Fidži',
	'Finsko',
	'Francie',
	'Francouzská Guyana',
	'Francouzská Polynésie',
	'Francouzská jižní a antarktická území',
	'Gabon',
	'Gambie',
	'Gruzie',
	'Německo',
	'Ghana',
	'Gibraltar',
	'Řecko',
	'Grónsko',
	'Grenada',
	'Guadeloupe',
	'Guam',
	'Guatemala',
	'Guernsey',
	'Guinea',
	'Guinea-Bissau',
	'Guyana',
	'Haiti',
	'Heardův ostrov a McDonaldovy ostrovy',
	'Svatý stolec',
	'Honduras',
	'Hongkong',
	'Maďarsko',
	'Island',
	'Indie',
	'Indonésie',
	'Írán',
	'Irák',
	'Irsko',
	'Isle of Man',
	'Izrael',
	'Itálie',
	'Jamajka',
	'Japonsko',
	'Jersey',
	'Jordánsko',
	'Kazachstán',
	'Keňa',
	'Kiribati',
	'Severní Korea',
	'Jižní Korea',
	'Kuvajt',
	'Kyrgyzstán',
	'Laos',
	'Lotyšsko',
	'Libanon',
	'Lesotho',
	'Libérie',
	'Libye',
	'Lichtenštejnsko',
	'Litva',
	'Lucembursko',
	'Macao',
	'Madagaskar',
	'Malawi',
	'Malajsie',
	'Maladivy',
	'Mali',
	'Malta',
	'Marshallovy ostrovy',
	'Martinik',
	'Mauritánie',
	'Mauricius',
	'Mayotte',
	'Mexiko',
	'Mikronésie',
	'Moldavsko',
	'Monako',
	'Mongolsko',
	'Černá Hora',
	'Montserrat',
	'Maroko',
	'Mosambik',
	'Myanmar (Barma)',
	'Namibie',
	'Nauru',
	'Nepál',
	'Nizozemsko',
	'Nová Kaledonie',
	'Nový Zéland',
	'Nikaragua',
	'Niger',
	'Nigérie',
	'Niue',
	'Norfolk',
	'Severní Mariany',
	'Norsko',
	'Omán',
	'Pákistán',
	'Palau',
	'Palestinská autonomie',
	'Panama',
	'Papua-Nová Guinea',
	'Paraguay',
	'Peru',
	'Filipíny',
	'Pitcairnovy ostrovy',
	'Polsko',
	'Portugalsko',
	'Portoriko',
	'Katar',
	'Makedonie',
	'Rumunsko',
	'Rusko',
	'Rwanda',
	'Réunion',
	'Svatý Bartoloměj',
	'Sv. Helena',
	'Svatý Kitts a Nevis',
	'Svatá Lucie',
	'Svatý Martin',
	'Svatý Pierre a Miquelon',
	'Svatý Vincenc a Grenadiny',
	'Samoa',
	'San Marino',
	'Svatý Tomáš a Princův ostrov',
	'Saúdská Arábie',
	'Senegal',
	'Srbsko',
	'Seychely',
	'Sierra Leone',
	'Singapur',
	'Sint Maarten',
	'Slovensko',
	'Slovinsko',
	'Šalamounovy ostrovy',
	'Somálsko',
	'Jihoafrická republika',
	'Georgie jižní',
	'Jižní Súdán',
	'Španělsko',
	'Srí Lanka',
	'Súdán',
	'Pakistán',
	'Surinam',
	'Svalbard a Jan Mayen',
	'Švédsko',
	'Švýcarsko',
	'Sýrie',
	'Tchaj-wan',
	'Tádžikistán',
	'Tanzanie',
	'Thajsko',
	'Východní Timor',
	'Togo',
	'Tokelau',
	'Tonga',
	'Trinidad a Tobago',
	'Tunisko',
	'Turecko',
	'Turkmenistán',
	'Turks a Caicos',
	'Tuvalu',
	'Uganda',
	'Ukrajina',
	'Spojené arabské emiráty',
	'Spojené království',
	'Menší odlehlé ostrovy USA',
	'Spojené státy americké',
	'Uruguay',
	'Uzbekistán',
	'Vanuatu',
	'Venezuela',
	'Vietnam',
	'Britské Panenské ostrovy',
	'Americké Panenské ostrovy',
	'Wallis a Futuna',
	'Západní Sahara',
	'Jemen',
	'Zambie',
	'Zimbabwe',
	'Ålandy',
].sort();

export const PRAGUE_OFFICES = [
	'f916bade-948a-4cc1-ad94-5a190c5c569e', // dev
	'451cc96f-9c07-450e-bd3e-29bd86ab5f7e', // prod
];
